
import React from 'react';
import {dollarToString} from '../../../lib/currency-utils';
import {loadDynamoItems} from "./actions";
import {calcCategoryAllocation, calcSecurityAllocation} from '../SAAllocator/actions';
import {deep_copy, obj_eq} from "../../../lib/js-utils";
import {objToUrlParam} from "../../../lib/url-util";
import {Spinner} from "../../funcs/utils";
import {DashboardTable} from "../dashboard-table";
import {AccountDerivedState, AccountState, PortfolioPerforamnceType} from "../../../lib/constants";
import {PopupContext} from "../BannerMenu/PopupContext";
import { sprintf } from "sprintf-js";
import {QueueType} from "../../../lib/proto/queue_proto";
import { saveAs } from "file-saver";
import { WLFUserTable } from "./wlf-user-table";
import {DeleteUserModal} from "./delete-user-modal";
import {DeleteUserAccountModal} from "./delete-user-account-modal";
import { AddUserAccountModal, on_prm_change } from "./add-user-account-modal";
import { FIRST_NAME, LAST_NAME, EMAIL, ACCOUNT_NUMBER, ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE } from "./prm";
import {FlowRender} from "../../../lib/flow-render";
import {CREATE_REBALANCE_OP} from "../../../lib/constants";
import {onboarding_start_segment} from "../../../lib/onboarding-utils";
import {AdminDashboardView} from "../../../lib/dashboard-constants";
import {dump_advisory_billing_csv, dump_sub_advisory_billing_csv, dump_user_csv} from "./csv_utils";
import {POPUP_TIMEOUT_MS} from "../../../lib/ui-constants";
import {RebalanceAllController, RebalanceAllDialog} from "./rebalance-all-dialog";
import {update_proxy_controller, UpdateProxyDialog} from "./update-proxy-controller";
import AdjustTimeModal from './adjust_time_modal';
import AdjustRiskModal from './adjust_risk_modal';
// import { eventNames } from 'superagent';

const ALL_PRMS = new FlowRender(0, [
  ACCOUNT_NUMBER, ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE,
  FIRST_NAME, LAST_NAME, EMAIL
]);

const REQUIRED_PROPS = [
  "employment_0_status",
  "employment_0_employer_name",
  "employment_0_employer_address",
  "employment_0_employer_city",
  "employment_0_zip",
  "employment_0_state",
  "employment_0_occupation",
  "Identification_0_Citizenship_Country",
  "Identification_0_Document",
  "Identification_0_Document_Expiration_Date",
  "Identification_0_Document_Issue_Date",
  "Identification_0_Driver_License_State",
  "Identification_0_Passport_Country",
  "Identification_0_Passport_Identification_Number",
]

class SA_UserPortfolios extends React.Component {

  constructor(props) {
    super(props);
    const new_state = {
      wlfs: [],
      page_token: null,
      loading: false,
      selected_row: -1,
      selected_wlf: -1,
      show_menu: -1,
      show_admin_menu: -1,
      sa_aum: null,
      download_billing: false,
      show_delete_user_dialog: null,
      show_delete_user_acct_dialog: null,
      show_add_account_dialog: null,
      show_add_user_dialog: null,
      show_adjust_time_modal: null,
      show_adjust_risk_modal: null,
      add_user_error: null,
      dialog_exec: false,
      sort_column: "Email",
      sort_descending: true,
      select_all: false,
      isSuperAdmin: true,
    }
    ALL_PRMS.init(new_state, {}, this);
    this.state = new_state;
    ACCOUNT_NUMBER.onChangeCallback = on_prm_change;
    ENVELOPE_ID.onChangeCallback = on_prm_change;
    ELECTRONIC_SIGNING_TYPE.onChangeCallback = on_prm_change;
    on_prm_change(this, this.state);
  }

  componentDidMount = () => {
    if (!this.props.sa_config) {
      this.props.getConfig();
    }
    this.maybeLoad();
    if (this.props.notification.executed.length === 0
      && this.props.notification.queued.length === 0) {
      this.props.loadQueueItems([QueueType.Rebalance.id]);
    }
    const irr = this.props.irr
    if (!irr.category || !irr.scores) {
      this.props.loadIRRScores();
    }

  };

  calcDerivedState = wlfs => {
    const notifs_queued = {};
    this.props.notification.queued.forEach(item => {
      notifs_queued[sprintf("%s_%d", item.username, item.index)] = 0;
    })
    wlfs.forEach(wlf_item => {
      wlf_item.items.forEach(item => {
        const acct_index = sprintf("%s_%d", item.user.username, item.acct_index);
        const has_queued = acct_index in notifs_queued;
        const account_state = item.account_state;
        if (account_state === AccountState.ONBOARDING) {
          if (item.onboarding && item.onboarding.is_stale) {
            item.derived_state = AccountDerivedState.STALE;
          } else {
            item.derived_state = AccountDerivedState.ONBOARDING;
          }
        } else if (account_state === AccountState.LIVE) {
          if (item.onboarding && item.onboarding.is_transfer) {
            item.derived_state = AccountDerivedState.ACCOUNT_TRANSFER;
          } else {
            item.derived_state = AccountDerivedState.ACCOUNT_PENDING;
          }
        } else if (has_queued) {
          item.derived_state = AccountDerivedState.REBALANCE_REQUESTED;
        } else if (item.num_rebal > 0) {
          item.derived_state = AccountDerivedState.ALLOCATED;
        } else {
          item.derived_state = AccountDerivedState.UNKNOWN;
        }
      })
    })
    return wlfs;
  }

  filterByView = (wlfs_, view) => {
    const wlfs = deep_copy(wlfs_);
    wlfs.forEach(wlf => {
      wlf.items = wlf.items.filter(item => {
        return this.showAcct(item, view)
      })
    });
    return wlfs;
  }

  maybeLoad = (force = false) => {
    const wlf_id = this.props.args.wlf_id;
    const users = this.props.users;
    if (!users.wlf[wlf_id] || force) {
      this.props.loadAllUsers(wlf_id, this.props.parent, this);
    } else {
      if (users.wlf[wlf_id]) {
        this.initSelectedItems(users.wlf[wlf_id].items);
      }
    }
  }

  initSelectedItems(items) {
    const selected = [];
    items.forEach((item, index) => {
      selected.push({
        selected: false,
        index,
        username: item.user.username,
        acct_index: item.acct_index,
      })
    });
    this.setState({ selected })
  }

  componentDidUpdate = prevProps => {
    const filter_view = args_ => {
      const args = deep_copy(args_);
      if (args.view) {
        delete args.view;
      }
      return args;
    }
    const curr_args = filter_view(this.props.args);
    const prev_args = filter_view(prevProps.args);
    if (!obj_eq(curr_args, prev_args)) {
      this.maybeLoad();
    }
    if (prevProps.notification.loading
      && !this.props.notification.loading
      && this.state.should_create_rebalance
      && this.state.created_category_security_allocation) {
      this.props.navigatePath("/super-admin/rebalance", { id: this.getRebalanceId() });
      this.props.appIsLoading(false);
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.should_create_rebalance && !nextState.is_processing_rebalance) {
      let portfolio = this.getPortfolio(nextProps);
      if (portfolio) {
        this.processRebalance(portfolio);
      }
    }
    return true;
  }

  getRebalanceId = () => {
    const index = parseInt(this.state.index, 10);
    const rebal = this.props.notification[this.state.username][index].current_notifs[0];
    return rebal.id;
  }

  showAcct = (acct, view) => {
    if (view === AdminDashboardView.all) {
      return true;
    } else if (view === AdminDashboardView.live) {
      return acct.account_state === AccountState.TEST_PORTFOLIO
        || acct.account_state === AccountState.TDA_PORTFOLIO;
    } else if (view === AdminDashboardView.rebalance) {
      let has_rebalance = false;
      this.props.notification.queued.forEach(queue_item => {
        if (queue_item.username === acct.user.username
            && queue_item.index === acct.acct_index) {
          has_rebalance = true;
        }
      });
      return has_rebalance;
    } else if (view === AdminDashboardView.onboarding) {
      return acct.account_state === AccountState.ONBOARDING;
    } else if (view === AdminDashboardView.onboarding_stale) {
      return acct.account_state === AccountState.ONBOARDING && acct.onboarding.is_stale;
    } else if (view === AdminDashboardView.password_not_set) {
      return !acct.confirmed
    }
  }

  hasUserAcct = (username, index) => {
    const intRe = /^\d+$/;
    return username && intRe.test(index);
  }

  getPortfolio = (props, username, index) => {
    if (!props) {
      props = this.props;
    }
    if (!username) {
      username = this.state.username;
    }
    if (index == null) {
      index = parseInt(this.state.index, 10);
    }

    if (!this.hasUserAcct(username, index)) {
      return null;
    }

    return props.portfolio[username]
      && props.portfolio[username][index]
      && props.portfolio[username][index].portfolio;
  }

  callCalcCategoryAllocation = (portfolio) => {
    const total_years = parseInt(portfolio.total_years, 10);
    const risk = portfolio.current_risk;
    const time = portfolio.current_year_t.toFixed(2) / total_years;

    return calcCategoryAllocation(this.props.token, total_years, risk, time);
  }

  callCalcSecurityAllocation = (portfolio, category_allocation) => {
    if (!category_allocation) {
      return Promise.resolve();
    }
    const amt_usd = portfolio.current_price;
    const current_security_alloc = this.get_security_alloc(portfolio);
    return calcSecurityAllocation(this.props.token, category_allocation, amt_usd, current_security_alloc);
  }

  calculate_new_risk = (current_risk) => {
    if (this.state.portfolio_performance === PortfolioPerforamnceType.IN_BAND) {
      return current_risk;
    }
    return this.state.portfolio_performance === PortfolioPerforamnceType.OVERPERFORM ? current_risk - 0.1 : current_risk + 0.1;
  }

  get_security_alloc = portfolio => {
    if (!portfolio || portfolio.rebalances.length === 0) {
      return {};
    }
    const last_rebal = portfolio.rebalances[portfolio.rebalances.length - 1];
    const security_alloc = {};
    Object.keys(last_rebal).forEach(sym => {
      if (sym[0] !== "_") {
        security_alloc[sym] = {
          size: last_rebal[sym].size,
        }
      }
    })
    return security_alloc;
  }

  renderAggregateTable = (title, aum, fee, fee_mtd) => {
    const title_item = strs => {
      const style = {
        fontWeight: "bold",
        paddingRight: "1rem",
      }
      const str_0 = strs.length > 1 ? strs[0] : " ";
      const str_1 = strs.length > 1 ? strs[1] : strs[0];
      return (
        <div style={style}>
          <div style={{height: "1rem", marginBottom: "0.2rem"}}>{str_0}</div>
          <div>{str_1}</div>
        </div>
      )
    }
    const div_style = {
      padding: "0.5rem, 0"
    }
    const aum_usd = aum ? aum.usd : 0;
    const data = [
      [
        title_item(["AUM", aum ? aum.date : "UNDEFINED"]),
        title_item(["Advisory Fee", fee ? fee._date : "UNDEFINED"]),
        title_item(["Advisory Fee", "MTD"]),
        title_item(["Sub Advisory Fee", fee ? fee._date : "UNDEFINED"]),
        title_item(["Sub Advisory Fee", "MTD"]),
      ],
      [
        (<div style={div_style}>{ dollarToString(aum_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee && fee.advisor.curr_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee_mtd && fee_mtd.advisory_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee && fee.sub_advisor.curr_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee_mtd && fee_mtd.sub_advisory_usd)}</div>),

      ]
    ];

    const styles = [
      {
        pred: row => row === 0,
        style: {
          borderBottom: "solid 1px black",
        }
      }
    ]

    return (
      <div style={{display: "flex", marginBottom: "2rem"}}>
        <div style={{fontSize: "1.5rem", fontWeight: "bold", width: "10rem"}}>{title}</div>
        <div style={{width: "2rem"}}/>
        <DashboardTable
          tableStyle={{margin: "0", width: "60rem"}}
          tdStyleLut={styles}
          data={data}/>
      </div>);
  }

  maybeRenderTotalAUM = () => {
    const wlf = this.getWlfItem();
    if (!wlf) {
      return null;
    }
    const { aum, fee, fee_mtd, ca_aum, ca_fee, ca_fee_mtd } = wlf.wlf;
    const do_ca = ca_aum && ca_fee;

    return (
      <div>
        { do_ca && this.renderAggregateTable("ALL WLF", ca_aum, ca_fee, ca_fee_mtd) }
        { this.renderAggregateTable("WLF", aum, fee, fee_mtd)}
      </div>
    )
  }

  async processRebalance(portfolio) {
    this.setState({ is_processing_rebalance: true });
    this.props.loadUserQueueItems(this.state.username, this.state.index, QueueType.Rebalance.id);
    let category_allocation = await this.callCalcCategoryAllocation(portfolio);
    let security_allocation = await this.callCalcSecurityAllocation(portfolio, category_allocation);
    const new_risk =  this.calculate_new_risk(portfolio.current_risk);

    this.props.loadIRRScores();
    this.setState({ created_category_security_allocation: true });
    this.props.createUserRebalance(
      this.state.username, this.state.index, portfolio.current_risk, new_risk, CREATE_REBALANCE_OP.UPDATE,
      category_allocation,
      security_allocation.security_allocation,
      security_allocation.trade_orders);
  }

  onRebalanceClick = async (wlf) => {
    this.props.appIsLoading(true);
    const index = parseInt(wlf.acct_index, 10);
    const username = wlf.user.username;
    const portfolio_performance = wlf.portfolio_performance;

    this.setState({
      should_create_rebalance: true,
      username: username,
      index: index,
      portfolio_performance: portfolio_performance,
    });

    let portfolio = this.getPortfolio(null, username, index);

    if (!portfolio) {
      this.props.loadPortfolio(username, index);
      return;
    }
    
    this.processRebalance(portfolio);
  }

  onEngageCashClick = () => {
    console.log('engage cash clicked');
  }

  onWlfTitleClick = () => {
    this.setState(prevState => ({
      show_admin_wlf_menu: !prevState.show_admin_wlf_menu
    }))
  }

  onMouseOver = (menu_id, isOver) => () => {
    if (!isOver) {
      this.setState({
        show_admin_wlf_menu: false
      })
    }
  }

  onMouseRowEvent = (wlf_index) => (index, enter) => {
    setTimeout(() => {
      index -= 1;
      if (enter) {
        this.setState({
          selected_row: index,
          selected_wlf: wlf_index,
        })
      } else if (index === this.state.selected_row) {
        this.setState({
          selected_row: -1,
          selected_wlf: -1,
          show_menu: -1,
        })
      }
    }, POPUP_TIMEOUT_MS);
  }

  onMouseRowClick = () => (index, ev) => {
    if (this.props.args.view === AdminDashboardView.rebalance) {
      return;
    }

    if (index >= this.table_row_lut.length) {
      console.log("row click", index, "row lut", this.table_row_lut.length);
      return;
    }
    const xlate_index = index;

    if (this.state.show_admin_menu !== -1 || this.state.show_menu !== -1) {
      // Just hide both menus
      this.setState({
        show_admin_menu: -1,
        show_menu: -1,
      });
      return;
    }

    // const menu_prop = ev.metaKey ? 'show_admin_menu': 'show_menu';
    // const other_menu_prop = !ev.metaKey ? 'show_admin_menu': 'show_menu';
    const menu_prop = ev.ctrlKey ? 'show_admin_menu': 'show_menu';
    const other_menu_prop = !ev.ctrlKey ? 'show_admin_menu': 'show_menu';

    if (this.state[menu_prop] === -1) {
      this.setState({
        item_index: index - 1,
        [menu_prop]: xlate_index,
        [other_menu_prop]: -1,
      })
    } else {
      this.setState({
        show_admin_menu: -1,
        show_menu: -1,
      })
    }
  }

  load_user_items = username => {

    return new Promise(resolve => {
      this.props.appIsLoading(true);

      loadDynamoItems(this.props.token, username)
        .then(result => {
          this.props.appIsLoading(false);

          result.onboarding.forEach((item, index) => {
            this.props.setOnboardingData(item.item, index, username);
          })
          result.dwolla.forEach((item, index) => {
            this.props.dwollaUpdate(item.item, index, username);
          })
          result.tda.forEach((item, index) => {
            this.props.tdaUpdate(item.item, index, username);
          })

          return resolve();
        })
    })
  }

  handle_proxy_onboarding = item => {

    const username = item.user.username;
    const segment = onboarding_start_segment(this.props.app.wlf);

    this.load_user_items(username)
      .then(() => {
        const url = sprintf("/super-admin/onboarding_%04d/%s", item.acct_index, segment);
        const args = {
          username,
          acct_index: item.acct_index,
          identity_id: item.user.partition,
          account_state: item.account_state,
          name: item.user.name.first + " " + item.user.name.last,
          tda_account_number: item.tda_account_number,
        }
        console.log("navigate to", url, args);
        this.props.navigatePath(url, args);
      });
  }

  popupMenuClick = (menu_id, button_id) => {
    if (menu_id === "admin_wlf_menu") {
      this.wlfMenuclick(button_id);
    }
    else {
      this.userMenuClick(menu_id, button_id);
    }
  }

  wlfMenuclick = (button_id) => {
    const args = deep_copy(this.props.args);
    
    args.view = button_id;
    this.props.navigatePath("/super-admin/user", args);
    
    this.setState({
      show_admin_wlf_menu: false
    })
  }

  setTableRowLut = (table_lut) => {
    this.table_row_lut = deep_copy(table_lut);
  }

  getWlfItem = () => {
    const wlf_id = this.props.args.wlf_id;
    return this.props.users.wlf[wlf_id];
  }

  calcMissingOnboardingProps = item => {
    const items = this.getWlfItem().items;
    if (!items) {
      return [];
    }

    let index = item.item_index;
    let found = false;

    while(index >= 0) {
      if (item.user.username !== items[index].user.username) {
        break;
      }
      if (items[index].acct_index === 0) {
        found = true;
        break;
      }
      index--;
    }

    if (!found) {
      return [];
    }

    const onboarding = items[index].onboarding;

    if (!onboarding) {
      return [];
    }

    return REQUIRED_PROPS.filter(prop => !(prop in onboarding));
  }

  userMenuClick = (menu_id, button_id) => {
    const index_prop = menu_id === "user_menu" ? 'show_menu' : 'show_admin_menu';
    const item_index = this.state[index_prop];

    const args = deep_copy(this.props.args);
    const item = this.getWlfItem().items[item_index];

    if (menu_id === "user_menu") {
      if (button_id === "dashboard") {
        args.username = item.user.username;
        args.acct_index = -1;
        if (args.page_token) {
          delete args.page_token;
        }
        this.props.navigatePath("/super-admin/user", args);
      } else if (button_id === "onboarding") {
        args.onboarding = item.user.username;
        args.acct_index = item.acct_index;
        if(args.page_token) {
          delete args.page_token;
        }
        this.props.navigatePath("/super-admin/user", args);
      } else if (button_id === "rebalance" || button_id === "rebalance-MTW") {
        args.username = item.user.username;
        args.acct_index = item.acct_index;
        if (args.page_token) {
          delete args.page_token;
        }
        if (button_id === "rebalance-MTW") {
          args.MTW = true;
        }
        this.props.navigatePath("/super-admin/allocator", args);
      } else if (button_id === "payments") {
        args.username = item.user.username;
        args.acct_index = item.acct_index;
        args.tab = "current";
        if (args.page_token) {
          delete args.page_token;
        }
        this.props.navigatePath("/super-admin/user/payments", args);
      } else if (button_id === "documents") {
        args.username = item.user.username;
        args.acct_index = item.acct_index;
        if (args.page_token) {
          delete args.page_token;
        }
        this.props.navigatePath("/super-admin/user/documents", args);
      } else if (button_id === "personal") {
        args.username = item.user.username;
        args.acct_index = item.acct_index;
        if (args.page_token) {
          delete args.page_token;
        }
        this.props.navigatePath("/super-admin/user/personal", args);
      } else if (button_id === "add_account") {
        this.setState({
          show_add_account_dialog: {
            username: item.user.username,
            name: item.user.name.first + " " + item.user.name.last,
            identity_id: item.user.partition,
            // This is the index of the nenwly created account
            index: item.user.accounts.length,
            wlf_id: item.wlf.id,
            confirmed: item.confirmed,
            missing_props: this.calcMissingOnboardingProps(item),
          }
        })
      } else if (button_id ===  "proxy_onboarding") {
        this.handle_proxy_onboarding(item);
      } else if(button_id === "adjust_time") {
        this.setState({
            show_adjust_time_modal: {
                accountState: item.account_state,
                account: item.acct,
                username: item.user.username,
                accountIndex: item.acct_index,
                wlfId: item.wlf.id,
                itemIndex: item_index
            }
        })
      } else if (button_id === "adjust_risk") {
        this.setState({
            show_adjust_risk_modal: {
                accountState: item.account_state,
                risk: item.risk,
                username: item.user.username,
                accountIndex: item.acct_index,
                wlfId: item.wlf.id,
                itemIndex: item_index
            }
        })
    }
    } else if (menu_id === "admin_menu") {
      if (button_id === "delete_user") {
        this.setState({
          show_delete_user_dialog: {
            username: item.user.username,
            name: item.user.name.first + " " + item.user.name.last,
          }
        })
      } else if (button_id === "delete_acct") {
        this.setState({
          show_delete_user_acct_dialog: {
            username: item.user.username,
            name: item.user.name.first + " " + item.user.name.last,
            index: item.acct_index,
            tda_account_number: item.tda_account_number,
          }
        })
      }
    }

    this.setState({
      show_menu: -1,
      show_admin_menu: -1,
      show_admin_wlf_menu: false,
      selected_row: -1,
    })
  }

  downloadUserTableCsv = wlf_id => () => {
    const csv = dump_user_csv(this.getWlfItem().items);
    const blob = new Blob([csv], { type: 'text/plain'});
    const today = new Date();
    saveAs(blob, sprintf(
      "%s_%04d-%02d-%02d.csv",
      wlf_id, today.getFullYear(), today.getMonth() + 1, today.getDate()));
  }

  downloadSubAdvisoryFeeCsv = (wlf_id) => () => {
    const csv = dump_sub_advisory_billing_csv(this.getWlfItem().items);
    const blob = new Blob([csv], { type: 'text/plain'});
    const today = new Date();
    saveAs(blob, sprintf(
      "%s_sub_advisory_%04d-%02d-%02d.csv",
      wlf_id, today.getFullYear(), today.getMonth() + 1, today.getDate()));
  }

  rebalanceAll = () => {
    const acct_items = [];
    const wlf_id = this.props.args.wlf_id;
    const user_items = this.props.users.wlf[wlf_id].items;

    for(let i= 0; i < this.state.selected.length; i++) {
      if (this.state.selected[i].selected) {
        const user_item = user_items[this.state.selected[i].index];
        acct_items.push({
          username: this.state.selected[i].username,
          index: this.state.selected[i].acct_index,
          name: user_item.user.name.first + " " + user_item.user.name.last,
          account_number: user_item.tda_account_number,
          account_type: user_item.account_type,
        })
      }
    }

    RebalanceAllController(this, acct_items).then();
  }

  updateProxy = () => {
    const items = this.getWlfItem().items
      .filter(item => item.account_state === AccountState.ONBOARDING_PROXY)
      .map(item => {
        return {
          username: item.user.username,
          index: item.acct_index,
        }
      });

    update_proxy_controller(this, items);
  }

  downloadAdvisoryFeeCsv = (wlf_id) => () => {
    const csv = dump_advisory_billing_csv(this.getWlfItem().items);
    const blob = new Blob([csv], { type: 'text/plain'});
    const today = new Date();
    saveAs(blob, sprintf(
      "%s_advisory_%04d-%02d-%02d.csv",
      wlf_id, today.getFullYear(), today.getMonth() + 1, today.getDate()));
  }

  maybeRenderTable = () => {
    if (this.state.loading) {
      return (
        <div align={"center"} style={{margin: "5rem"}}>
          <Spinner size={"2rem"}/>
        </div>
      );
    }

    const item = this.getWlfItem();

    if (!item) {
      return (
        <div align={"center"} style={{margin: "5rem"}}>
          <span>EMPTY</span>
        </div>
      )
    }

    return (
      <div>
        <WLFUserTable
          component={this}
          args={this.props.args}
          wlf_item={item}
          token={this.props.token}
        />
      </div>
    )
  };

  onPopupMenuClick = (menu_id, button_id) => {

    const args = deep_copy(this.props.args);

    if (menu_id === "wlf") {
      if (button_id === "all" && ('wlf_id' in args || 'page_token' in args)) {
        delete args.wlf_id;
        delete args.page_token;
        this.props.navigatePath(this.props.path + objToUrlParam(args));
      } else if (button_id !== "all" && (args.wlf_id !== button_id || 'page_token' in args)) {
        args.wlf_id = button_id;
        delete args.page_token;
        this.props.navigatePath(this.props.path + objToUrlParam(args));
      }
    } else if (menu_id === "view") {
      if (args.view !== button_id) {
        args.view = button_id;
        this.props.navigatePath(this.props.path, args);
      }
    }
  };

  onBannerClick = button_id => {
    if (button_id === "left_arrow" && "page_token" in this.props.args) {
      // We have paged forward, we can still navigate back
      window.history.back();
    } else if (button_id === "right_arrow" && this.state.page_token) {
      const args = deep_copy(this.props.args);
      args.page_token = this.state.page_token;
      this.props.navigatePath(this.props.path + objToUrlParam(args));
    }
  };

  handleAdjustTimeModalClose = () => {
    this.setState({
        show_adjust_time_modal: false
    })
  }

  handleAdjustRiskModalClose = () => {
    this.setState({
        show_adjust_risk_modal: false
    })
  }

  render = () => {

    const provider_state = {
      onPopupMenuClick: this.popupMenuClick,
    }

    const delete_user_modal = this.state.show_delete_user_dialog
      ? (
        <DeleteUserModal
          component={this}
          name={this.state.show_delete_user_dialog.name}
          username={this.state.show_delete_user_dialog.username}/>
      ) : null;
    const delete_user_acct_modal = this.state.show_delete_user_acct_dialog
      ? (
        <DeleteUserAccountModal
          component={this}
          name={this.state.show_delete_user_acct_dialog.name}
          username={this.state.show_delete_user_acct_dialog.username}
          index={this.state.show_delete_user_acct_dialog.index}
          tda_account_number={this.state.show_delete_user_acct_dialog.tda_account_number}
          />) : null;
    const add_user_account_modal = this.state.show_add_account_dialog
      ? (
        <AddUserAccountModal
          component={this}
          name={this.state.show_add_account_dialog.name}
          username={this.state.show_add_account_dialog.username}
          identity_id={this.state.show_add_account_dialog.identity_id}
          index={this.state.show_add_account_dialog.index}
          wlf_id={this.state.show_add_account_dialog.wlf_id}
          confirmed={this.state.show_add_account_dialog.confirmed}
          missing_props={this.state.show_add_account_dialog.missing_props}
        />)
      : null;

    const update_proxy_modal = this.state.update_proxy_items
      ? (<UpdateProxyDialog component={this}/>)
      : null;

    const rebal_all_modal = this.state.rebal_all
      ? (<RebalanceAllDialog component={this}/>)
      : null;

    const adjust_time_modal = this.state.show_adjust_time_modal
        ? (<AdjustTimeModal
            token={this.props.token}
            account={this.state.show_adjust_time_modal.account}
            username={this.state.show_adjust_time_modal.username}
            accountIndex={this.state.show_adjust_time_modal.accountIndex} 
            handleClose={this.handleAdjustTimeModalClose}
            wlfId={this.state.show_adjust_time_modal.wlfId}
            itemIndex={this.state.show_adjust_time_modal.itemIndex}
        />) 
        : null;

    const adjust_risk_modal = this.state.show_adjust_risk_modal
        ? (<AdjustRiskModal
            token={this.props.token}
            accountIndex={this.state.show_adjust_risk_modal.accountIndex}
            username={this.state.show_adjust_risk_modal.username} 
            risk={this.state.show_adjust_risk_modal.risk} 
            handleClose={this.handleAdjustRiskModalClose}
            wlfId={this.state.show_adjust_risk_modal.wlfId}
            itemIndex={this.state.show_adjust_risk_modal.itemIndex}
        />) 
        : null;

    return (
      <div>
        <section className="section">
          <div className="container">
            { this.maybeRenderTotalAUM() }
            <PopupContext.Provider value={provider_state}>
              { this.maybeRenderTable() }
            </PopupContext.Provider>
          </div>
          { delete_user_modal }
          { delete_user_acct_modal }
          { add_user_account_modal }
          { rebal_all_modal }
          { update_proxy_modal }
          { adjust_time_modal }
          { adjust_risk_modal }
        </section>
      </div>
    )
  }
}

export { SA_UserPortfolios };
